import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
/**
 * Main component
 */
export class AppComponent {
  title = 'VDG4CB';
}
